import React, { Component } from "react";
import { Radio } from "antd";
import Enterprise from "../Enterprise";
import Personal from "../Personal";
import "./style.less";
const RadioGroup = Radio.Group;
const clsPrefix = "c-header-container";

const SHOW_PERSON_VALUE = 1;
const SHOW_ENTER_PRISE_VALUE = 2;

class InvoiceTitle extends Component {
  constructor() {
    super();
    this.state = {
      showPerson: true,
      showEnterPrise: false,
      showValue: 1
    };
  }

  onChange = e => {
    this.setState({
      showValue: e.target.value
    });
  };

  render() {
    const { showValue } = this.state;
    return (
      <div className={clsPrefix}>
        <div className="showType">
          <span>开具类型：</span>
          <RadioGroup onChange={this.onChange} value={this.state.showValue}>
            <Radio value={SHOW_PERSON_VALUE}>个人</Radio>
            <Radio value={SHOW_ENTER_PRISE_VALUE}>企业</Radio>
          </RadioGroup>
        </div>
        {SHOW_ENTER_PRISE_VALUE === showValue ? <Enterprise /> : <Personal />}
      </div>
    );
  }
}
export default InvoiceTitle;
